import styled from 'styled-components';
import { getFadeAnimation } from '@/styles/helpers';

export const ModalWrapper = styled.div<{ $isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  z-index: 10200;
  align-items: center;
  justify-content: center;
  padding: 15px;

  ${({ $isOpen }) => getFadeAnimation($isOpen)}
`;

export const Backdrop = styled.div<{ $isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  transition: opacity 0.2s ease-out;
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  background-color: ${({ theme }) => theme.palette.overlay[40]};
`;

export const ModalContent = styled.div<{
  $isOpen: boolean;
  $maxWidth: number;
  $borderRadius: number;
  $background?: string;
}>`
  width: 100%;
  display: flex;
  flex-direction: column;
  z-index: 2;
  border-radius: ${({ $borderRadius }) => `${$borderRadius}px`};
  transition: opacity 0.2s ease-out;
  max-width: ${({ $maxWidth }) => `${$maxWidth}px`};
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  background-color: ${({ theme, $background }) =>
    $background || theme.palette.primary.background};
`;
